import React, { useState, useEffect } from 'react'
import { Dialog, InputField, Text } from 'shared/ui'
import { Chip } from '@material-ui/core'

function CustomFilterDialog(props) {
  const { open, onClose, customSortFields, onCustomSortChange, selectedSortField, sortFieldOptions } = props

  const [selectedFields, setSelectedFields] = useState([])

  useEffect(() => {
    if (selectedSortField) {
      const selectedValues = selectedSortField.value.split(',')
      setSelectedFields(selectedValues)
    }
  }, [selectedSortField])

  const handleSelectOption = (value) => {
    setSelectedFields((prev) => {
      if (prev.includes(value)) {
        return prev.filter((v) => v !== value)
      } else {
        return [...prev, value]
      }
    })
  }

  const onSave = () => {
    const selectedValues = selectedFields.filter(f => f !== 'customsort')
    /** do this process to make all labels properly sorted */
    const fieldNames = []
    selectedValues.forEach((value) => {
      const fieldOption = [...sortFieldOptions, ...customSortFields].find(f => f.value === value)
      if (fieldOption) {
        fieldNames.push(fieldOption.text)
      } else {
        fieldNames.push(value) // fallback to value if no text found
      }
    })

    onCustomSortChange({
      value: selectedValues.join(','),
      text: `Custom ${fieldNames?.length > 0 ? `(${fieldNames.join(', ')})` : ''}`,
      isCustom: true
    })
    onClose()
  }

  const actionButtons = [
    {
      kind: "check",
      label: "Save",
      onClick: onSave,
    },
    {
      kind: "close",
      label: "Cancel",
      onClick: onClose,
    }
  ]

  return (
    <Dialog
      title="Sort By"
      open={open}
      onClose={onClose}
      actionButtons={actionButtons}>
      {/* checkboxes */}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {[...sortFieldOptions, ...customSortFields].map((field, index) => (
          <InputField
            key={index}
            label={field.text}
            value={selectedFields.includes(field.value) ? field.value : ''}
            onChange={() => handleSelectOption(field.value)}
            type="checkbox"
            fullWidth
          />
        ))}
      </div>

      {/* conditional chips */}
      {selectedFields.filter(f => f !== 'customsort').length > 0 && (
        <div style={{ marginTop: '10px' }}>
          {selectedFields.filter(f => f !== 'customsort').map((field, index) => {
            const fieldOption = [...sortFieldOptions, ...customSortFields]
              .find(f => f.value === field)

            return (
              <Chip
                key={index}
                label={fieldOption ? fieldOption.text : field}
                onDelete={() => handleSelectOption(field)}
                style={{ margin: '5px' }}
              />
            )
          })}
        </div>
      )}
    </Dialog>
  )
}

export default CustomFilterDialog